export default __webpack_public_path__ + "static/media/baton_common.48456789.jpg";